import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { interval, map } from 'rxjs';
import { CheckOutRegisterSessionMovement } from '@vierkant-software/types__api';
import { DateTime } from 'luxon';
import { APIStates, AppService } from 'src/services/app.service';
import { RegisterSessionStateService } from 'src/services/register-session-state.service';
import { formatTime } from 'src/util/formatting/time';
import { RegisterSessionAction } from './checkout-register-session-dialog.component';

/** the shown runtime counts minutes */
const RUNTIME_TICK_MS = 60 * 1000;

@Component({
  selector:    'checkout-register-session',
  templateUrl: './checkout-register-session.component.haml',
  styleUrls:   ['./checkout-register-session.component.sass'],
  standalone:  false
})
export class CheckoutRegisterSessionComponent {
  private app = inject(AppService);
  registerSession = inject(RegisterSessionStateService);

  protected readonly Action = RegisterSessionAction;
  private now = toSignal(interval(RUNTIME_TICK_MS).pipe(map(() => DateTime.serverTime())), { initialValue: DateTime.serverTime() });

  runtime = computed(() => {
    const openedAt = this.registerSession.session()?.opened_at;
    if (!openedAt)
      return '';
    return formatTime(this.now().diff(openedAt), this.app.vtranslate.instant('CHECKOUT.REGISTER_SESSION.RUNTIME_FORMAT'), ['hours', 'minutes']);
  });

  pendingAction = computed(() => this.registerSession.pendingMovement()?.movement === CheckOutRegisterSessionMovement.withdrawal
    ? RegisterSessionAction.withdrawal : RegisterSessionAction.deposit);
  canFinishPending = computed(() => this.registerSession.canFinish(this.registerSession.pendingMovement()?.movement));
  pendingLabelKey = computed(() => this.pendingAction() === RegisterSessionAction.withdrawal
    ? 'CHECKOUT.REGISTER_SESSION.STATUS.PENDING_WITHDRAWAL' : 'CHECKOUT.REGISTER_SESSION.STATUS.PENDING_DEPOSIT');

  get loggedIn(): boolean {
    return this.app.state === APIStates.loggedIn;
  }

  reload(): void {
    void this.registerSession.reload();
  }
}
